<template>
  <layout>
    <div class="row">
      <div class="col-12 form-field-wrapper">
        <span class="text">We're sorry but we cannot find the page you requested. Please try again</span>
      </div>
    </div>
  </layout>
</template>
<script>
// import vueConfig from "vue.config";
import layout from "../../layout/main.vue";

export default {
  name: "Thank you",
  data() {
    return {
        
    }
  },
  components: { layout },
  computed: {
    
  },
  methods: {
    
  },
  mounted() {
    
  }
};
</script>
